import { render, staticRenderFns } from "./FormerLeader.vue?vue&type=template&id=415b552c"
import script from "./FormerLeader.vue?vue&type=script&lang=js"
export * from "./FormerLeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports